import { render, staticRenderFns } from "./ApprovalOrder.vue?vue&type=template&id=7bf74221"
import script from "./ApprovalOrder.vue?vue&type=script&lang=js"
export * from "./ApprovalOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports